module.exports = __webpack_public_path__ + "static/img/meet-our-executive-team_4.c715418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/meet-our-executive-team_4.png
// module id = XkAq
// module chunks = 0